import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Register from "./Register";
import Login from "./Login";
import RedirectWithToken from "./RedirectWithToken"; // Import RedirectWithToken
import Success from "./Success";
import { ApiDataProvider } from "./ApiDataContext"; // Import API context

function App() {
  return (
    <ApiDataProvider>
      <Router> {/* ✅ Wrap everything inside Router */}
        <Routes>
          <Route path="/" element={<RedirectWithToken />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/success" element={<Success />} />
        </Routes>
      </Router>
    </ApiDataProvider>
  );
}

export default App;